import { MenuContainerTabs } from "../components/Routes";

export function disableAllButDetails() {
    return Object.keys(MenuContainerTabs)
        .filter((key) => {
            const data = MenuContainerTabs[key];
            if (data.key !== MenuContainerTabs.DETAILS.key) {
                return true;
            }
            return false;
        })
        .map((filteredKeys) => {
            return MenuContainerTabs[filteredKeys].key.toString();
        });
}
export function disableEposNow() {
    const disableKeys = [MenuContainerTabs.PREFERENCES.key, MenuContainerTabs.OPEN_ORDERS.key, MenuContainerTabs.NEW_ORDERS.key];
    return Object.keys(MenuContainerTabs)
        .filter((key) => {
            const data = MenuContainerTabs[key];
            if (disableKeys.indexOf(data.key) > -1) {
                return true;
            }
            return false;
        })
        .map((filteredKeys) => {
            return MenuContainerTabs[filteredKeys].key.toString();
        });
}

export function disableSquare() {
    const disableKeys = [MenuContainerTabs.REPORTS.key];
    return Object.keys(MenuContainerTabs)
        .filter((key) => {
            const data = MenuContainerTabs[key];
            if (disableKeys.indexOf(data.key) > -1) {
                return true;
            }
            return false;
        })
        .map((filteredKeys) => {
            return MenuContainerTabs[filteredKeys].key.toString();
        });
}

export function disableReports() {
    const disableKeys = [MenuContainerTabs.REPORTS.key];
    return Object.keys(MenuContainerTabs)
        .filter((key) => {
            const data = MenuContainerTabs[key];
            if (disableKeys.indexOf(data.key) > -1) {
                return true;
            }
            return false;
        })
        .map((filteredKeys) => {
            return MenuContainerTabs[filteredKeys].key.toString();
        });
}